<template>
  <div class="form-group" :class="setPlaceholderClasses">
    <input
      :disabled="disabled"
      :value="value"
      :id="id"
      class="form-control"
      @input="update()"
      ref="input"
    />
    <label :style="numberCharacterToHight(text)" :for="id">{{ text }}</label>
  </div>
</template>
<script>
import placeholder from "@mixins/placeholder.js";
export default {
  name: "volcan-input-text",
  mixins: [placeholder],
  props: {
    text: String,
    syncSeo: Boolean,
    disabled: Boolean,
    resource: Object,
  },
  data: function () {
    return {
      id: null,
    };
  },
  mounted() {
    this.id = "input" + this._uid;
  },
  methods: {
    numberCharacterToHight(text) {
      if (text.length > 60) {
        return "font-size: 0.6em";
      }

      if (text.length > 43) {
        return "font-size: 0.7em";
      }
      return "";
    },
    update() {
      this.$emit("input", this.$refs.input.value);
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// components/AdminTools/divers/input-text.vue